// src/Home.js
import React from "react";

import Slide1 from "../assets/img/flash image 1.png";
import Slide2 from "../assets/img/flash image 2 (1).png";
import Slide3 from "../assets/img/flash image 3.png";
import Slide4 from "../assets/img/flash image 4.png";

import { Box,  } from "@mui/material";


import ServicesSection from "./ServicesSection";




import ChatBotWidget from "./chat";





import FullpageImageSlider from "./Silder";
import VisionMissionPage from "./Mission";
import TeamSection from "./TeamSection";
import FludeeHero from "./FludeBtn";
import AchievementsMorePage from "./AchievementsMorePage";

const slides = [Slide1, Slide2, Slide3, Slide4];

const Home = () => {
  const [active, setActive] = React.useState(0);

  const next = React.useCallback(() => {
    setActive((p) => (p + 1) % slides.length);
  }, []);

  const prev = React.useCallback(() => {
    setActive((p) => (p - 1 + slides.length) % slides.length);
  }, []);

  React.useEffect(() => {
    const id = setInterval(next, 3500);
    return () => clearInterval(id);
  }, [next]);

  const touchStartX = React.useRef(null);
  const onTouchStart = (e) => {
    touchStartX.current = e.touches?.[0]?.clientX ?? null;
  };
  const onTouchEnd = (e) => {
    const startX = touchStartX.current;
    const endX = e.changedTouches?.[0]?.clientX ?? null;
    if (startX === null || endX === null) return;

    const diff = startX - endX;
    const threshold = 50;
    if (diff > threshold) next();
    if (diff < -threshold) prev();
    touchStartX.current = null;
  };

  return (
    <Box  marginTop={"10"}>
      {/* ---------------- Upper Hero Slider Section ---------------- */}
     
 {/*<Box
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        sx={{
          position: "relative",
          overflow: "hidden",
          height: { xs: "70vh", sm: "75vh", md: "85vh" },
          display: "flex",
          alignItems: "center",
          color: "white",
          bgcolor: "#0b0b0b",
        }}
      >
         Slides (reduced width + centered) 
        {slides.map((img, idx) => (
          <Box
            key={idx}
            sx={{
              position: "absolute",
              inset: 0,
              opacity: active === idx ? 1 : 0,
              transition: "opacity 900ms ease",
              zIndex: 0,

              // ✅ center container for image
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: { xs: 2, sm: 3, md: 6 },
            }}
          >
            <Box
              component="img"
              src={img}
              alt={`slide-${idx}`}
              draggable={false}
              sx={{
                // ✅ width reduced
                width: "100%",
                maxWidth: { xs: 520, sm: 780, md: 1050, lg: 1200 },
                height: "auto",
                maxHeight: { xs: "56vh", sm: "60vh", md: "70vh" },

                // ✅ contain so it doesn't crop
                objectFit: "contain",
                objectPosition: "center",

                // ✅ smooth scale (optional)
                transform: active === idx ? "scale(1.02)" : "scale(1.06)",
                transition: "transform 2500ms ease",
                willChange: "transform",
                display: "block",

                // ✅ make it look premium
                borderRadius: 18,
                filter: "drop-shadow(0 18px 45px rgba(0,0,0,0.45))",
              }}
            />
          </Box>
        ))}

       
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            background:
              "linear-gradient(90deg, rgba(0,0,0,0.70) 0%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0.70) 100%)",
          }}
        />

        <IconButton
          onClick={prev}
          aria-label="Previous slide"
          sx={{
            position: "absolute",
            left: { xs: 8, md: 16 },
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 6,
            color: "white",
            bgcolor: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(6px)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
            display: { xs: "none", sm: "inline-flex" },
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        <IconButton
          onClick={next}
          aria-label="Next slide"
          sx={{
            position: "absolute",
            right: { xs: 8, md: 16 },
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 6,
            color: "white",
            bgcolor: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(6px)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
            display: { xs: "none", sm: "inline-flex" },
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>

        
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 14, sm: 20 },
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 7,
            display: "flex",
            gap: 1,
            px: 1.5,
            py: 0.9,
            borderRadius: 999,
            bgcolor: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.15)",
          }}
        >
          {slides.map((_, i) => (
            <Box
              key={i}
              onClick={() => setActive(i)}
              sx={{
                width: active === i ? 26 : 10,
                height: 10,
                borderRadius: 99,
                cursor: "pointer",
                transition: "all 250ms ease",
                backgroundColor:
                  active === i ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.45)",
              }}
            />
          ))}
        </Box>

       
        <Container sx={{ position: "relative", zIndex: 5 }}>
          <Grid container>
            <Grid item xs={12} md={8} lg={7}>
              <Typography
                variant="h3"
                component="h3"
                gutterBottom
                sx={{
                  fontWeight: 800,
                  lineHeight: 1.1,
                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                }}
              >
               
   </Typography>

              <Typography
                variant="h6"
                sx={{
                  mb: 4,
                  opacity: 0.95,
                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                }}
              >
             


             </Typography>
                  <br/>
                  <br/>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1.4,
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 700,
                    boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
                  }}
                >
                Get Started
                </Button>
              </Box>

              <Typography
                sx={{
                  mt: 1.5,
                  opacity: 0.8,
                  fontSize: { xs: "0.85rem", sm: "0.9rem" },
                  display: { xs: "block", sm: "none" },
              }}
              >
             
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ---------------- Main Section ---------------- */}



      
      <FullpageImageSlider/>

      <ServicesSection />
      < FludeeHero/>
      {/* <FludeePage /> */}
      {/* <FludeeProductPage />   */}
      {/* <ClinicalValidationPage />   */}
      <VisionMissionPage/>
      <AchievementsMorePage/>
      {/* <AchievementPage /> */}
      {/* <TechnologyRDPage /> */}
     {/* <TestimonialVideoPage/>*/ }
      {/* <ProductsPipelinePage /> */}
     
      {/* <ResearchPublicationsSimple /> */}
    
      {/* <MUEFoundersPage /> */}
      <TeamSection />
       
      {/* <IPRegulatoryPathwayPage /> */}
      <ChatBotWidget />
    </Box>
  );
};

export default Home;
